<template>
	<div class="wrapperBlock">
		<div class="wrapperBlock_title">
				<span>Invoices</span>
		</div>
		<div class="wrapperBlock_body">
			<tab-block
					:tab="tab"
					:tab-list="tabList"
					custom-class="clientTabs"
					@updateTab="onTab($event)"
			>
				<v-tab-item>
					<main-table
							padding="0"
							:headers="headers"
							:list-items="previousInvoice"
							:is-hide-header="false"
							:items-per-page-amount="3"
							:pages="[3, 10]"
							@updateClickButton="onClickButton"
					></main-table>
				</v-tab-item>
				<v-tab-item>
					<main-table
							padding="0"
							:headers="headers"
							:list-items="notPaidInvoices"
							:is-hide-header="false"
							:items-per-page-amount="3"
							:pages="[3, 10]"
			        @updateClickButton="onClickButton"
					></main-table>
				</v-tab-item>
			</tab-block>
		</div>
	</div>
</template>

<script>
import TabBlock from "@/shared/TabBlock/TabBlock";
import getClonedObject from "@/helper/getClonedObject";
import {
	blockInvoicesHeader,
	defaultTabs
} from "@/components/Accounting/CustomerInvoices/CustomerInvoicesCreate/BlockInvoices/constants";

export default {
	name: "BlockInvoices",
	components: { TabBlock },
	props: {
		previousInvoice: Array,
		notPaidInvoices: Array
	},
	data: () => ({
		tabList: [],
		tab: 0,
		headers: []
	}),
	methods: {
		onTab(value) {
			this.tab = value;
		},
		onClickButton({ key, item }) {
			if (key === "view") {
				this.$emit('updateView', item);
			}
		}
	},
	created() {
		this.tabList = getClonedObject(defaultTabs);
		this.headers = blockInvoicesHeader;
	},
};
</script>

<style scoped lang="scss">
@import "../blockStyles";
</style>
